import(/* webpackMode: "eager" */ "/vercel/path0/src/app/products/[slug]/page.tsx");
